import { render, staticRenderFns } from "./ysgkDetail.vue?vue&type=template&id=66a03c40&scoped=true"
import script from "./ysgkDetail.vue?vue&type=script&lang=js"
export * from "./ysgkDetail.vue?vue&type=script&lang=js"
import style0 from "./ysgkDetail.vue?vue&type=style&index=0&id=66a03c40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a03c40",
  null
  
)

export default component.exports